import { useEffect, useRef } from 'react';
import { Checkbox } from '../../primitives/Checkbox.js';
import styles from './DataTable.module.css';
import { cx } from '../../utils/cx.js';

export type DataTableRowSelectControlProps = {
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  ariaLabel: string;
  onChange: () => void;
  /** Header page select-all in first column */
  variant?: 'row' | 'header';
};

export function DataTableRowSelectControl({
  checked,
  indeterminate,
  disabled,
  ariaLabel,
  onChange,
  variant = 'row',
}: DataTableRowSelectControlProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const input = containerRef.current?.querySelector('input[type="checkbox"]');
    if (input instanceof HTMLInputElement) input.indeterminate = Boolean(indeterminate);
  }, [indeterminate]);

  return (
    <div
      ref={containerRef}
      className={cx(
        variant === 'header' ? styles.headerSelectControl : styles.rowSelectControl,
      )}
      data-datatable-rowclick-ignore
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={styles.selectTriggerShell}
        data-indeterminate={indeterminate ? '' : undefined}
      >
        <div className={styles.selectTriggerBtn}>
          <Checkbox
            checked={checked}
            disabled={disabled}
            aria-label={ariaLabel}
            showErrorText={false}
            onChange={() => onChange()}
          />
        </div>
      </div>
    </div>
  );
}
